export default "__VITE_ASSET__6e0438be__"